export default {
    items: [],
    tab: 'form',
    loading: false,
}